
import React from 'react';
import { Helmet } from 'react-helmet';
import SEOMetadata from '@/components/SEOMetadata';
import HeroSection from "@/components/HeroSection";
import CTASection from "@/components/CTASection";
import ConsultingBenefits from "@/components/consulting/ConsultingBenefits";
import ConsultingApproach from "@/components/consulting/ConsultingApproach";
import ConsultingServices from "@/components/consulting/ConsultingServices";
import ConsultingMethodology from "@/components/consulting/ConsultingMethodology";
import ConsultingBackground from "@/components/consulting/ConsultingBackground";
import ConsultingTestimonials from "@/components/consulting/ConsultingTestimonials";
import ConsultingFAQ from "@/components/consulting/ConsultingFAQ";
import { webPageStructuredData } from '@/data/structuredData';

const Consulting = () => {
  return (
    <>
      <SEOMetadata
        metaTitle="Katalysator-Führung & Executive Coaching | Nürnberg"
        metaDescription="Executive Coaching für Manager und Führungskräfte. Katalysator-Führung mit emotionaler Intelligenz in Bayern. Nürnberg, München + Remote. ✆ 09171-9892118"
        title="Katalysator-Führung & Executive Coaching | Nürnberg"
        description="Executive Coaching für Manager und Führungskräfte. Katalysator-Führung mit emotionaler Intelligenz in Bayern. Nürnberg, München + Remote."
        imageUrl="/images/og-portrait.jpg"
        pageName="Consulting"
        primaryLink="/consulting"
        keywords="Katalysator-Führung, Executive Coaching Bayern, Führungskräfte-Entwicklung Nürnberg, Management Coaching Nürnberg, Business Coaching München"
        canonicalUrl="https://joerg-hoermann.de/consulting"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(webPageStructuredData({
            name: "Katalysator-Führung & Strategisches Consulting",
            description: "Führungskräfte-Coaching mit emotionaler Intelligenz. Katalysator-Führung für Unternehmen in Bayern und deutschlandweit.",
            url: "https://joerg-hoermann.de/consulting",
            aboutTopics: ["katalysatorFuehrung", "executiveCoaching", "emotionaleIntelligenz", "selbstfuehrung"]
          }))}
        </script>
      </Helmet>
      <main>
      <HeroSection
        title="Führung mit Herz & Verstand"
        subtitle="Executive Coaching & Führungskräfte-Entwicklung für Manager und Leader"
        description="Entwickeln Sie eine zukunftsfähige Führungskultur, die wirtschaftlichen Erfolg mit emotionaler Intelligenz verbindet. Ich begleite Sie und Ihr Unternehmen auf dem Weg zu nachhaltiger Führung, die sowohl Menschen als auch Zahlen im Blick behält."
        primaryCTA={{ text: "Erstgespräch vereinbaren", link: "/kontakt" }}
        backgroundClass="bg-joerg-50"
        imageUrl="/images/blog/business-meeting.jpg"
        hideHeroLogo={true}
      />


      {/* AI-Summary / AEO Abstract */}
      <section className="sr-only" aria-label="Zusammenfassung" data-speakable="summary">
        <p>Jörg Hörmann begleitet Manager und Führungskräfte mit dem Katalysator-Führung Ansatz. Executive Coaching verbindet emotionale Intelligenz mit wirtschaftlicher Exzellenz – für nachhaltige Führungskultur in der Metropolregion Nürnberg und deutschlandweit.</p>
      </section>

      {/* Reordered for better information hierarchy */}
      {/* Golden Snippet – AEO Definition */}
      <section className="py-10 bg-white" data-speakable="definition">
        <div className="container mx-auto px-4">
          <p className="max-w-3xl mx-auto text-lg lg:text-xl text-joerg-700 leading-relaxed italic border-l-4 border-primary/30 pl-6">
            <strong className="not-italic">Was ist Katalysator-Führung?</strong>{" "}
            Katalysator-Führung beschreibt einen Führungsstil, der Potenziale freisetzt, ohne Energie zu verbrauchen. Wie ein Katalysator in der Chemie: Er beschleunigt, ohne sich selbst zu verbrauchen. Das Ziel ist eine Führungskultur, in der Menschen Verantwortung übernehmen wollen, nicht müssen.
          </p>
        </div>
      </section>
      <ConsultingBenefits />
      
      <ConsultingApproach />
      
      {/* Golden Sentence – emotionaler Break */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <p className="max-w-2xl mx-auto text-center italic text-joerg-700 text-lg lg:text-xl leading-loose">
            „Ein Katalysator beschleunigt Prozesse, ohne sich selbst zu verbrauchen. Genau so führen die besten Manager: Sie befähigen Teams, statt sie zu kontrollieren."
          </p>
        </div>
      </section>

      <ConsultingServices />
      
      <ConsultingTestimonials />
      
      <ConsultingMethodology />
      
      <ConsultingBackground />

      <ConsultingFAQ />

      <CTASection
        title="Ein ruhiges Gespräch über Ihre nächsten Schritte"
        description="Lassen Sie uns unverbindlich herausfinden, ob und wie ich Sie begleiten kann."
        primaryCTA={{ text: "Erstgespräch vereinbaren", link: "/kontakt" }}
        backgroundClass="bg-gradient-to-br from-[#EDF5E9] to-[#E8F1FB] text-joerg-800"
      />
    </main>
    </>
  );
};

export default Consulting;
